import { Navigate, useLocation } from "react-router-dom"
import { useApp } from "./context/AppContext"


const ProtectedRoutes = ({children}) => {
    const {isAuth} = useApp()
    const location = useLocation()

    if (!isAuth) {
        return (
            <Navigate to='/auth/login' state={{from: location}}/>
        )
    }
    return children
}

export default ProtectedRoutes